<template>
  <div>
    <loading-cube v-if="loading"/>
    <div v-if="!loading">
      <PageHeading
          v-if="workerData"
          :back="{ name: 'a_timesheet_r2_select_site_worker', params: {company_id, start_date, end_date, order_id, order_job_id}, query: {timesheet: timesheet_id} }"
      >
        <template #title>
          <router-link :to="{name: 'company_record', query: {company_id}}">
            {{ company?.company_name }}
          </router-link>
          <br/>
          <router-link :to="{ name: 'a_timesheet_r2_select_sites', params: {company_id, start_date, end_date} }">Submit Sites</router-link>
          ->
          <router-link
              :to="{ name: 'a_timesheet_r2_select_site_worker', params: {company_id, start_date, end_date, order_id, order_job_id} }">
            Submit Timesheets
          </router-link>
          ->
          Submit Timesheet
        </template>

        <template>
          <h2>
            <router-link :to="{name: 'worker_profile', query:{timesheet: timesheet_id}}">
              {{ ` ${workerData.first_name} ${workerData.surname} - ${workerData.job_title}` }}
            </router-link>
          </h2>
          <p v-if="workerData?.rate">
            Rate: <Rate :data="workerData.rate"/>
          </p>

          <p>
            Selected Timesheet period: {{ dateFormat(period) }}.
            <router-link :to="{name: 'a_timesheet_r2_select_period', params: {company_id}}">(change)</router-link>
          </p>
        </template>
      </PageHeading>

      <div class="pane">
        <timesheet_form_container
            :company_id="company_id"
            :end_date="end_date"
            :order_id="order_id"
            :order_job_id="order_job_id"
            :start_date="start_date"
            :timesheet_id="timesheet_id"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page_heading {
  padding-left: 1em;
  margin-bottom: 2em;
}

.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
}
</style>

<script>
import timesheet_form_container from './components/timesheet_form_container.vue'
import loadingCube from "loaders/generic_record_loader.vue";
import PageHeading from "../components/shared/PageHeading.vue";
import {dateFormat} from '../components/shared/index';
import Rate from '../components/shared/Rate.vue';

export default {
  components: {
    PageHeading,
    loadingCube,
    timesheet_form_container,
    Rate
  },
  props: {
    company_id: {required: true},
    start_date: {required: true},
    end_date: {required: true},
    order_id: {required: true},
    order_job_id: {required: true},
    timesheet_id: {required: true},
  },
  data() {
    return {
      loading: false,
      error: null,
      period: this.end_date,
      workerData: null,
      company: null,
      site: null,
    }
  },
  async beforeMount() {
    await this.init();
  },
  methods: {
    dateFormat,

    async init() {
      this.loading = true;
      await this.fetchWorker();
      await this.fetchSite();
      await this.fetchSupportingData();
      this.loading = false;
    },

    async fetchSupportingData() {
      const result = await axios.get(this.crmApiPath + 'company/' + this.company_id);
      if (result.status !== 200) {
        console.error('Could not fetch company');
        return;
      }
      this.company = result.data;
    },

    async fetchWorker() {
      let result = await axios.get(`${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/order_job/${this.order_job_id}/workers/${this.timesheet_id}?submission_date=${this.period}`);
      if (result.status !== 200) {
        console.error('Could not fetch timesheet:', err);
        this.error = 'Failed to load timesheet data';
        return;
      }
      this.workerData = {...result.data.data};
    },

    async fetchSite() {
      const result = await axios.get(`${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/sites/${this.order_id}/${this.order_job_id}?submission_date=${this.period}`);

      if (result.status !== 200) {
        console.error('Could not fetch site');
        return;
      }
      this.site = {...result.data.data};
    },
  }
}
</script>
